import core from "@/helpers/client";
const clientAppsService = {
  async headClientAppAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps?no-cache=1`,
      params
    );
    return result;
  },
  async getClientAppsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps?no-cache=1`,
      params
    );
    return result;
  },
  async getClientAppAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps/${id}?no-cache=1`
    );
    return result;
  },
  async createClientAppAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps`,
      model
    );
    return result;
  },
  async updateClientAppAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps/${id}`,
      model
    );
    return result;
  },
  async deleteClientAppAsync(clientAppsId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/ClientApps/${clientAppsId}/ClientApps/${id}`
    );
    return result;
  },
};
export default clientAppsService;
